import 'css-chunksrc/client/common/layout/styles.scss';export default {
  "layout": "_layout_1dic1_1",
  "sideBar": "_sideBar_1dic1_8",
  "sideBarHeader": "_sideBarHeader_1dic1_15",
  "zoneCreation": "_zoneCreation_1dic1_24",
  "navigation": "_navigation_1dic1_28",
  "planzone": "_planzone_1dic1_34",
  "logoBox": "_logoBox_1dic1_43",
  "button": "_button_1dic1_49",
  "projectHistory": "_projectHistory_1dic1_57",
  "main": "_main_1dic1_61",
  "zonesList": "_zonesList_1dic1_66",
  "footer": "_footer_1dic1_72",
  "closed": "_closed_1dic1_81",
  "logo": "_logo_1dic1_43",
  "links": "_links_1dic1_117",
  "flexWrapper": "_flexWrapper_1dic1_123"
};